<template>
  <div
    v-if="pressKitEntries?.length || pressEntries?.length"
    :class="$style.root"
  >
    <div :class="$style.label">
      {{ $t('pages.press.label') }}
    </div>

    <ul
      v-if="pressKitEntries?.length || pressEntries?.length"
      :class="$style.list"
    >
      <li
        v-for="(entry, index) in entriesPaginated"
        :key="entry?.id || index"
        :class="$style.entry"
      >
        <SharedPressKitEntriesThumbnailComponent
          :data="entry"
          v-if="entry?.type === 'pressKit'"
          :includeLabel="true"
          :titleOneLine="true"
          :includeRelation="includeRelation"
        />
        <SharedPressEntriesThumbnailComponent
          :data="entry"
          :titleOneLine="true"
          v-else-if="entry?.type === 'press'"
        />
      </li>
    </ul>

    <button
      v-if="entries?.length > limit && paginated"
      :class="$style.button"
      @click="paginated = false"
    >
      {{ $t('shared.showAll', { count: entries?.length }) }}
    </button>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  page: Object,
  includeRelation: {
    type: Boolean,
    default: true
  }
})

const limit = 3
const paginated = ref(true)

const pressKitEntries = props?.page?.pressKitEntries?.data
const pressEntries = props?.page?.pressEntries?.data

const entries = [...pressKitEntries?.map(i => { return { ...i, type: 'pressKit'} }), ...pressEntries?.map(i => { return { ...i, type: 'press' } })]
const entriesPaginated = computed(() => paginated.value ? entries?.slice(0, limit) : entries)
</script>

<style module>
.root {
  composes: container from global;

  margin-top: calc(var(--unit--vertical) * 2);
}

.label {
  composes: font-helvetica font-size-small from global;
  composes: label from global;
}

.list {
  composes: reset-list from global;

  padding: var(--padding--element);
  border: var(--stroke--default) solid;
}

.entry:not(:first-of-type) {
  border-top: var(--stroke--default) solid;

  margin-top: var(--padding--element--top);
  padding-top: var(--padding--element--top);
}

.button {
  composes: reset-button font-helvetica font-size-small link from global;
  margin-top: var(--padding--element--top);
}
</style>
